import React from 'react';
import {
  Table, TableBody, TableRow, TableCell, Button, Dialog, DialogActions,
} from '@mui/material';

export default ({
  show = false, onClose = null, properties = [], title = '', onCancel, onApply,
}) => (
  <Dialog
    open={show}
    onClose={onClose}
    aria-labelledby="responsive-dialog-title"
    className="dialog"
  >
    <h2 style={{ fontSize: 18, marginLeft: 15, marginBottom: 0 }}>{title}</h2>
    <Table style={{ minWidth: 300 }}>
      <TableBody>
        {properties.map(([prop, value, value2], i) => (
          <TableRow key={i}>
            <TableCell style={{ fontWeight: '500' }}>{prop}</TableCell>
            <TableCell>{value}</TableCell>
            {value2 && <TableCell>{value2}</TableCell>}
          </TableRow>
        ))}
      </TableBody>
    </Table>
    <DialogActions>
      <div>
        {
          onCancel && (
            <Button
              onClick={onCancel}
              variant="outlined"
              style={{ marginRight: 5 }}
            >
            Cancel
            </Button>
          )
        }
        {onApply && (
          <Button
            onClick={onApply}
            color="primary"
            variant="contained"
          >
        Apply
          </Button>
        )}
      </div>
    </DialogActions>
  </Dialog>
);
